import { render } from "./UserSettings.vue?vue&type=template&id=35bc261f&scoped=true"
import script from "./UserSettings.vue?vue&type=script&lang=js"
export * from "./UserSettings.vue?vue&type=script&lang=js"

import "./UserSettings.vue?vue&type=style&index=0&id=35bc261f&lang=scss"
import "./UserSettings.vue?vue&type=style&index=1&id=35bc261f&lang=scss&scoped=true"

import exportComponent from "/Users/emiliedannenberg/Documents/GitHub/nola-paddle-routes/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35bc261f"]])

export default __exports__